/** Acting as / viewing as (ADR-006 §6, operator decisions 14–18). */
import { IdempotencyHeaders } from './common.js';
import { ActAsLogPage, ActAsLogQuery, ActAsResponse, StartActAsBody } from './actas.js';
import { API_BASE, defineRoute } from './route.js';
export const actAsRoutes = {
    'actAs.start': defineRoute({
        id: 'actAs.start',
        method: 'POST',
        path: `${API_BASE}/sessions/act-as`,
        summary: 'Act as (or view as) someone for up to 30 minutes, with a reason',
        description: 'Founder → AD, member, sales, marketing; AD → member, sales, marketing. 403 with a specific message for a peer or ' +
            'senior, yourself, a disabled user, or while already acting. The member is not notified. Every write while acting ' +
            'records both people; in view mode every write is refused.',
        access: { auth: 'session', anyOf: ['actAs.member'], note: 'Founder and associate director. Others: 403.' },
        headers: IdempotencyHeaders,
        body: StartActAsBody,
        success: { status: 201, description: 'Acting (the next request is as them)', schema: ActAsResponse },
        errors: ['no_session', 'forbidden', 'not_found', 'validation_failed'],
        idempotency: 'key',
        rateLimit: 'write',
    }),
    'actAs.stop': defineRoute({
        id: 'actAs.stop',
        method: 'POST',
        path: `${API_BASE}/sessions/act-as/stop`,
        summary: 'Stop acting or viewing (back to yourself)',
        description: 'Idempotent: stopping when not acting returns acting_as null. Allowed in view mode.',
        access: { auth: 'session', note: 'The person who started it (the session is theirs).' },
        success: { status: 200, description: 'Back to yourself', schema: ActAsResponse },
        errors: ['no_session'],
        idempotency: 'safe',
        rateLimit: 'write',
        allowWhileViewing: true,
    }),
    'actAs.log': defineRoute({
        id: 'actAs.log',
        method: 'GET',
        path: `${API_BASE}/security/act-as-log`,
        summary: 'Every acting / viewing session: who, as whom, why, how long (managers only)',
        description: 'Members never see who acted as them (operator decision 16); managers see it here and in the audit trail.',
        access: { auth: 'session', anyOf: ['audit.read'], note: 'Founder and associate director. Others: 403.' },
        query: ActAsLogQuery,
        success: { status: 200, description: 'A page, newest first', schema: ActAsLogPage },
        errors: ['no_session', 'forbidden', 'validation_failed'],
        idempotency: 'safe',
        rateLimit: 'default',
    }),
};
//# sourceMappingURL=routes.actas.js.map